import { useEffect, useState } from "react";
import { api } from "./api";

// Fonte única de verdade de permissões no frontend (revalida no load).
export function usePermissions() {
  const [perm, setPerm] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/me/recursos").then(({ data }) => { if (alive) setPerm(data); }).catch(() => { if (alive) setPerm({ ativo: false, recursos: {} }); });
    return () => { alive = false; };
  }, []);
  const can = (chave) => !!(perm?.recursos || {})[chave];
  return { perm, can, loading: perm === null };
}

export function daysLeft(iso) {
  if (!iso) return null;
  const d = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(d / 86400000));
}
